import React from 'react';
import type { FC } from 'react';
import { Box, Text, Alert } from '@wix/cli-ui-kit';

interface Props {
  packageManagerRunCmd?: string;
}

export const ServeDeprecationMessage: FC<Props> = ({
  packageManagerRunCmd,
}) => {
  return (
    <Box rowGap={1} paddingBottom={1} flexDirection="column">
      <Alert type="error">Deprecation Notice</Alert>
      <Text>
        <Text skin="info">`serve`</Text> command is being replaced by{' '}
        <Text skin="info">`preview`</Text> command.
      </Text>
      <Text>
        Run{' '}
        <Text skin="info">
          {packageManagerRunCmd
            ? `\`${packageManagerRunCmd} wix app preview\``
            : '`wix app preview`'}
        </Text>{' '}
        instead.
      </Text>
    </Box>
  );
};
